import React from 'react';

import Table from './Partials/Table';

const Students: React.FC = () => {
  return <Table />;
};

export default Students;
